import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";

export const getExhibitors = createAsyncThunk(
  "exhibitors/getExhibitors",
  async (args, thunkAPI) => {
    const {
      type,
      status,
      eventId,
      orderBy,
      pageSize,
      pageNumber,
      searchQuery,
    } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/exhibitors`,
        method: "get",
        params: { pageSize, pageNumber, searchQuery, status, orderBy, type },
      });

      return { data: response };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los tickets. Error: ",
        error
      );
    }
  }
);

export const getExhibitorsToExport = createAsyncThunk(
  "exhibitors/getExhibitorsToExport",
  async (args, thunkAPI) => {
    const {
      type,
      status,
      eventId,
      orderBy,
      pageSize,
      pageNumber,
      searchQuery,
    } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/exhibitors/export`,
        method: "get",
        params: { pageSize, pageNumber, searchQuery, status, orderBy, type },
      });

      return { data: response };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los tickets. Error: ",
        error
      );
    }
  }
);

export const getExhibitorsById = createAsyncThunk(
  "exhibitors/getExhibitorsById",
  async (args, thunkAPI) => {
    const { eventId, id } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/exhibitors/${id}`,
        method: "get",
      });

      return { data: response };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los tickets. Error: ",
        error
      );
    }
  }
);

export const updateExhibitors = createAsyncThunk(
  "exhibitors/updateExhibitors",
  async (args, thunkAPI) => {
    const { id, eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/exhibitors/${id}`,
      method: "patch",
      data,
    });
    return { data: response };
  }
);

export const deleteExhibitors = createAsyncThunk(
  "exhibitors/deleteExhibitors",
  async (args, thunkAPI) => {
    const { id, eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/exhibitors/${id}`,
      method: "delete",
    });
    return { data: response };
  }
);

export const exhibitorsSlice = createSlice({
  name: "exhibitors",
  initialState: {
    totalRows: 0,
    exhibitors: [],
    exhibitorsById: [],
    inputSearch: "",
    pendingDelete: false,
    pendingUpdate: false,
    pendingExhibitors: false,
    pendingExhibitorsById: false,
    pendingExportExhibitors: false,
  },
  reducers: {
    setInputSearch: (state, action) => {
      state.inputSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExhibitors.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.pendingExhibitors = false;
        state.exhibitors = data.data;
        state.totalRows = JSON.parse(data?.headers["x-pagination"]).totalCount;
      })
      .addCase(getExhibitors.pending, (state) => {
        state.pendingExhibitors = true;
      })
      .addCase(getExhibitors.rejected, (state) => {
        state.pendingExhibitors = false;
      })
      .addCase(getExhibitorsToExport.fulfilled, (state, action) => {
        state.pendingExportExhibitors = false;
      })
      .addCase(getExhibitorsToExport.pending, (state) => {
        state.pendingExportExhibitors = true;
      })
      .addCase(getExhibitorsToExport.rejected, (state) => {
        state.pendingExportExhibitors = false;
      })
      .addCase(getExhibitorsById.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.exhibitorsById = data.data;
        state.pendingExhibitorsById = false;
      })
      .addCase(getExhibitorsById.pending, (state) => {
        state.pendingExhibitorsById = true;
      })
      .addCase(getExhibitorsById.rejected, (state) => {
        state.pendingExhibitorsById = false;
      })
      .addCase(updateExhibitors.fulfilled, (state, action) => {
        state.pendingUpdate = false;
      })
      .addCase(updateExhibitors.pending, (state) => {
        state.pendingUpdate = true;
      })
      .addCase(updateExhibitors.rejected, (state) => {
        state.pendingUpdate = false;
      })
      .addCase(deleteExhibitors.fulfilled, (state, action) => {
        state.pendingDelete = false;
      })
      .addCase(deleteExhibitors.pending, (state) => {
        state.pendingDelete = true;
      })
      .addCase(deleteExhibitors.rejected, (state) => {
        state.pendingDelete = false;
      });
  },
});

export const { setInputSearch } = exhibitorsSlice.actions;

export default exhibitorsSlice.reducer;
